import { Repository } from 'app/services/database/repository';
import { PresentationModel, Section } from 'app/views/presentations/models/presentation.model';

export class PresentationRepository extends Repository<PresentationModel> {
    public get path() { return '/presentations/'; }
    public get videoKey() { return '/video'; }
    public get videoIdKey() { return 'id'; }

    public async updateVideoThumbnailUrl(presentationId: string, value: string) {
        await this.db.set(this.path + presentationId + this.videoKey, 'thumbnailPath', value);
    }

    public async get(key: string): Promise<PresentationModel> {
        let presentation = await super.get(key);
        let sections: Section[] = [];

        if (presentation.sections) {
            for (const section of presentation.sections) {
                sections.push(Object.assign(new Section(), section));
            }
        }

        presentation.sections = sections;
        return Object.assign(new PresentationModel(), presentation);
    }

    public async update(key: string, value: PresentationModel) {
        let firebaseModel = Object.assign({}, value);
        for (const section of firebaseModel.sections) {
            delete section.formControls;
        }
        await super.update(key, firebaseModel);
    }

    public async set(key: string, value: PresentationModel) {
        let firebaseModel = Object.assign({}, value);
        for (const section of firebaseModel.sections) {
            delete section.formControls;
        }
        await super.set(key, firebaseModel);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/database/presentation.repository.ts